import { render } from "./IconButton.vue?vue&type=template&id=3a2d9f70&scoped=true"
import script from "./IconButton.vue?vue&type=script&lang=js"
export * from "./IconButton.vue?vue&type=script&lang=js"

import "./IconButton.vue?vue&type=style&index=0&id=3a2d9f70&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a2d9f70"],['__file',"src/components/button/IconButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3a2d9f70"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3a2d9f70', __exports__)) {
    console.log('reload')
    api.reload('3a2d9f70', __exports__)
  }
  
  module.hot.accept("./IconButton.vue?vue&type=template&id=3a2d9f70&scoped=true", () => {
    console.log('re-render')
    api.rerender('3a2d9f70', render)
  })

}


export default __exports__